import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M42.75 24.5501C47.61 25.4701 52.48 26.3701 57.34 27.2601C58.59 21.2301 58.89 15.3101 56.54 9.59012C52.53 -0.179884 42.07 0.750075 38.24 2.61007C34.35 4.50007 29.8 9.86011 29.23 22.3301C33.76 22.9001 38.26 23.7001 42.75 24.5501Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M36.3301 14.19C36.3301 14.19 39.9601 5.85004 46.9001 5.27004C53.4801 4.72004 55.8201 9.40004 55.8201 9.40004"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M39.47 14.6801C39.47 14.6801 43.19 9.48006 49.21 9.23006C54.66 9.01006 57.14 12.2901 57.63 16.4101"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M41.54 14.77C41.54 14.77 46.33 11.88 50.62 13.78C54.17 15.35 54.09 19.15 54.09 19.15"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M42.2001 1.89C42.2001 1.89 35.1802 1.14999 34.9302 14.44"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M46.5465 20.7686L35.6157 13.6507L46.7845 7.75734L46.5465 20.7686ZM23.8339 20.7682L23.6047 7.75737L34.764 13.6506L23.8339 20.7682Z"
        fill="white"
        stroke={outline}
      />
      <path
        d="M63.16 26.18C56.44 18.15 48.2399 14.98 35.2499 14.98C22.2599 14.98 13.5099 18.65 7.2199 26.18C-3.4801 38.99 3.73992 66.53 3.73992 66.53C3.73992 66.53 4.48987 44.07 12.6899 37.42C19.6799 31.76 26.0899 33.93 35.1899 33.93C44.2899 33.93 50.7099 31.76 57.6899 37.42C65.8899 44.07 66.6399 66.53 66.6399 66.53C66.6399 66.53 73.87 38.98 63.16 26.18Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.82968 26.1799C6.82968 26.1799 0.54975 37.9299 6.14975 50.1299"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M63.5498 26.1799C63.5498 26.1799 69.8297 37.9299 64.2297 50.1299"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M35.1899 33.92V14.98" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M18.13 18.48C18.13 18.48 11.0301 24.2 10.8101 39.18"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M24.8999 16.3401C24.8999 16.3401 17.6299 22.0101 17.6299 34.3401"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M27.9299 15.8401C27.9299 15.8401 24.4098 20.9001 24.8498 33.0101"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M55.6199 20.3C55.6199 20.3 62.0499 28.01 62.2699 42.98"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M45.54 16.3401C45.54 16.3401 52.8101 22.0101 52.8101 34.3401"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M40.0298 15.8401C40.0298 15.8401 43.5497 20.9001 43.1097 33.0101"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M41.52 16.01C41.52 16.01 45.04 21.07 44.6 33.18"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
